<template>
  <div class="flex items-center h-full py-1">
    <div class="flex-1 min-w-0">
      <div class="sensitive font-medium text-gray-900 truncate">{{ titleCase(patientName) }}</div>
      <div class="sensitive text-xs text-blue-600 font-mono">{{ params.data?.patient_id }}</div>
    </div>
  </div>
</template>

<script>
const KEEP = new Set(['II','III','IV','JR','SR','MD','DO','NP','PA','RN']);

export default {
  name: 'Coding_PatientCell',
  props: ['params'],
  computed: {
    patientName() {
      const data = this.params.data || {};
      const last = data.last_name || '';
      const first = data.first_name || '';
      if (last || first) return `${last}, ${first}`.replace(/^, |, $/g, '');
      return 'Unknown';
    }
  },
  methods: {
    titleCase(str) {
      if (!str) return str;
      return str.split(/\s+/).map(w => {
        if (KEEP.has(w.replace(/[,.]$/, '').toUpperCase())) return w.toUpperCase();
        return w.toLowerCase().replace(/^\w/, c => c.toUpperCase());
      }).join(' ');
    }
  }
};
</script>
